'use client'

import { Box, CloseButton, HStack } from '@chakra-ui/react'
import { HTMLArticle } from 'ui'
import type { MapLocatorPopoverSettings, MapLocatorTag } from 'ecosystem'
import type { MapLocatorEntry } from './useMapLocator'
import { MAP_LOCATOR_CN, mapLocatorCn as cn } from './constants'
import { formatDistance, popoverContent } from './utils'

interface LocationPanelProps {
  item: MapLocatorEntry
  tags: MapLocatorTag[]
  popover: MapLocatorPopoverSettings
  showDistance: boolean
  labels: {
    closePopover: string
    distanceUnit: string
  }
  onClose: () => void
}

/** The SIDE_PANEL rendering of a selected point — same content as the info window. */
const LocationPanel = ({
  item,
  tags,
  popover,
  showDistance,
  labels,
  onClose
}: LocationPanelProps) => {
  const content = popoverContent(popover, {
    item,
    tags,
    distanceLabel:
      showDistance && item.distanceKm !== undefined
        ? formatDistance(item.distanceKm, labels.distanceUnit)
        : undefined
  })

  return (
    <Box
      bg="white"
      borderWidth="1px"
      className={cn(MAP_LOCATOR_CN.PANEL)}
      p={4}
      rounded="md"
      shadow="md"
    >
      <HStack align="start" justify="space-between" spacing={2}>
        <HTMLArticle content={content} flex={1} />

        <CloseButton aria-label={labels.closePopover} onClick={onClose} size="sm" />
      </HStack>
    </Box>
  )
}

export default LocationPanel
